import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export function capitalize(value: string) {
  return value
    .split(' ')
    .map((val) => val.charAt(0).toUpperCase() + val.substr(1).toLowerCase())
    .join(' ');
}

const USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

/**
 * TODO: This needs to replace format money.
 */
export function formatMoneyV2(value: number | bigint): string {
  return USDollar.format(value);
}

export function formatMoney(value: number) {
  return `$${value.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}`;
}

export function formatDate(value: string) {
  return dayjs(value).format('MMMM D, YYYY');
}

export function formatShortDate(value: string) {
  return dayjs(value).format('MM/DD/YYYY');
}

export function formatUTCShortDate(value: string | Date) {
  return formatUTC(value);
}

export function formatUTC(value: string | Date, format = 'MM/DD/YYYY') {
  return dayjs.utc(value).format(format);
}

export function formatShortDateTime(value: string) {
  return dayjs(value).format('MM/DD/YYYY hh:mma');
}
